// // Use $ instead of jQuery without replacing global $
(function ($) {
    /*
     * Hero slider
     */
    $(document).ready(function () {
        $('.col-two-with-image.slider .slider').slick({
            draggable: true,
            arrows: false,
            dots: true,
            fade: true,
            speed: 1000,
            autoplaySpeed: 10000,
            dotsClass: 'custom-dots',
            infinite: true,
            autoplay: true,
            pauseOnHover: true,
            pauseOnFocus: false,
            adaptiveHeight: true,
            cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
        });
        if($(".col-two-with-image .slider").hasClass('slick-slider')){
            $(".col-two-with-image .slider").addClass("scroll-reveal").attr("data-reveal","col-two-with-image");
        }else{
            $(".col-two-with-image .slider .content-wrap").addClass("scroll-reveal").attr("data-reveal","col-two-with-image");
        }
    });
    $(window).on("load",function () {
        $('.col-two-with-image').removeClass("initial-load");
    });
})(jQuery);